export class InfoMessageItem {
    id: number = -1;
    header: string = '';
    message: string = '';
    activateDate!:  Date; // | undefined;
    deActivateDate!: Date; // | undefined;
    importance: number = 0; // default info
}